module.exports = __webpack_public_path__ + "static/media/address-book.2b0cc1f3.svg";